import { render, staticRenderFns } from "./MessageInput.vue?vue&type=template&id=5783ed96&scoped=true&"
import script from "./MessageInput.vue?vue&type=script&lang=js&"
export * from "./MessageInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5783ed96",
  null
  
)

export default component.exports